angular.
module("dx.webapp.api").
factory("dxApiV1TeacherData", function apiV1TeacherDataService(
	$window
) {
	"use strict";

	function teacherDataUrl(userId, organizationId) {
		var url = "/api/v1/migrations/teacherdata";
		var queryParams = {};

		if (userId) {
			queryParams.userId = userId;
		}

		if (organizationId) {
			queryParams.organizationId = organizationId;
		}

		var queryString = $window.jQuery.param(queryParams);

		if (queryString) {
			url += "?" + queryString;
		}

		return url;
	}

	return {
		url: teacherDataUrl,
	};
});
